import { getArticleById } from 'http/articleApi';

import { defaultArticleEntity } from 'common/constants';
import { IArticle } from 'common/types';
import { notify, parseDate } from 'common/utils';
import { makeAutoObservable } from 'mobx';
import { ArticleCategoryModel } from 'store/article-categoriy-model';

export class ArticleModel {
  _loading = false;
  _article: IArticle = defaultArticleEntity;
  _category: ArticleCategoryModel = new ArticleCategoryModel();

  get loading() {
    return this._loading;
  }

  set loading(loading: boolean) {
    this._loading = loading;
  }

  get article() {
    return this._article;
  }

  set article(article: IArticle) {
    this._article = article;
  }

  get id() {
    return this.article.id;
  }

  get title() {
    return this.article.title;
  }

  get slug() {
    return this.article.slug;
  }

  get categoryId() {
    return this.article.categoryId;
  }

  get category() {
    return this._category ?? '';
  }

  set category(category: ArticleCategoryModel) {
    this._category = category;
  }

  get metaTitle() {
    return this.article.metaTitle ?? '';
  }

  get metaDescription() {
    return this.article.metaDescription ?? '';
  }

  get metaKeywords() {
    return this.article.metaKeywords ?? '';
  }

  get content() {
    return this.article.content;
  }

  get published() {
    return this.article.published;
  }

  get updatedAt() {
    return parseDate(this.article.updatedAt ?? '');
  }

  fetchArticle = async (id: number) => {
    try {
      const article = await getArticleById(id);

      if (article) {
        this.article = article;
        this.category = new ArticleCategoryModel(article.categoryId);
      }
    } catch (e) {
      notify('Can`t load article', 'error');

      setTimeout(() => {
        window.location.href = '/articles/new';
      }, 500);
    }
  };

  fetchData = async (articleId?: number, article?: IArticle) => {
    this.loading = true;

    try {
      if (article) {
        this._article = article;
        this._category = new ArticleCategoryModel(
          article.categoryId,
          article.category,
        );
      }

      if (articleId && !article) {
        await this.fetchArticle(articleId);
      }
    } catch (e) {
      notify(`Error, reason:${e}`, 'error');
    } finally {
      this.loading = false;
    }
  };

  constructor(articleId?: number, article?: IArticle) {
    this.fetchData(articleId, article);

    makeAutoObservable(this);
  }
}
